import React, { useContext } from 'react'
import { Blocks } from 'lucide-react'
import UserContext from '../../../../context/users'
import {
  getIntegrationsForRole,
  IntegrationRenderer,
} from '@/utils/integration-registry.jsx'

export default function Integrations({ id }) {
  const [user] = useContext(UserContext)
  const filteredIntegrations = getIntegrationsForRole(user.role)

  return (
    <div className="flex flex-col gap-6">
      <header className="flex items-end justify-between gap-4">
        <div className="flex flex-col gap-1">
          <div className="flex items-center gap-2">
            <Blocks size={18} style={{ color: 'var(--dash-primary)' }} />
            <h2
              className="text-xl font-semibold tracking-tight"
              style={{ color: 'var(--dash-text)' }}
            >
              Integrações
            </h2>
          </div>
          <p
            className="text-xs"
            style={{ color: 'var(--dash-text-muted)' }}
          >
            Conecte seu assistente a serviços externos para expandir suas capacidades.
          </p>
        </div>
        <span
          className="rounded-full px-3 py-1 text-[11px] font-medium tabular-nums"
          style={{
            background: 'var(--dash-primary-soft)',
            color: 'var(--dash-primary)',
            border: '1px solid var(--dash-primary-border)',
          }}
        >
          {filteredIntegrations.length} disponíveis
        </span>
      </header>

      <div className="columns-1 gap-4 lg:columns-2 2xl:columns-3">
        {filteredIntegrations.map((item) => (
          <div className="mb-4 break-inside-avoid" key={item.type}>
            <IntegrationRenderer
              type={item.type}
              assistantID={id}
            />
          </div>
        ))}
      </div>
    </div>
  )
}
